import { animated, useSpring } from "@react-spring/web";
import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";

const AnimatedSuccessAlert = ({
  isVisible,
  title,
  message,
}: {
  isVisible: boolean;
  title: string;
  message: string;
}) => {
  const { opacity } = useSpring({
    opacity: isVisible ? 1 : 0,
    config: { duration: 400 },
  });

  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    if (isVisible) {
      import("../../assets/animations/alerts/alerta-success.json").then((data) =>
        setAnimationData(data.default)
      );
    } else {
      setAnimationData(null);
    }
  }, [isVisible]);

  return (
    <animated.div
      style={{
        opacity,
        pointerEvents: isVisible ? "auto" : "none",
      }}
      className="fixed inset-x-0 top-4 z-[9999] flex justify-center sm:justify-end px-4"
    >
      {isVisible && (
        <div className="flex w-full max-w-sm sm:max-w-md md:max-w-lg items-start rounded-xl border border-stroke bg-white p-3 sm:p-4 shadow-lg dark:border-strokedark dark:bg-boxdark">
          {/* Animación */}
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center">
            {animationData && (
              <Lottie
                animationData={animationData}
                loop={false}
                style={{ width: 55, height: 55 }}
              />
            )}
          </div>

          {/* Texto */}
          <div className="ml-3 flex flex-col overflow-hidden">
            <h4 className="text-sm font-semibold text-black dark:text-white truncate sm:whitespace-normal">
              {title}
            </h4>
            <p className="text-sm font-medium text-[#1EA779] dark:text-[#66BB6A] leading-tight break-words whitespace-normal">
              {message}
            </p>
          </div>
        </div>
      )}
    </animated.div>
  );
};

export default React.memo(AnimatedSuccessAlert);
